import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.title',
    defaultMessage: 'Try our Compliance Stage',
  },
  subtitle: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.subtitle',
    defaultMessage: 'And automate your document review!',
  },
  discover: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.discover',
    defaultMessage: 'Discover',
  },
  dismissAriaLabel: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.dismissAriaLabel',
    defaultMessage: 'Dismiss',
  },
});
